var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.094 21.6925L12.0929 21.6915C8.85913 18.7511 6.23572 16.3642 4.41174 14.1281C2.59643 11.9027 1.65088 9.91785 1.65088 7.79461C1.65088 4.34641 4.34202 1.65088 7.77588 1.65088C9.72303 1.65088 11.6041 2.56345 12.8292 4.00598L13.4009 4.67913L13.9725 4.00598C15.1976 2.56345 17.0787 1.65088 19.0259 1.65088C22.4597 1.65088 25.1509 4.34641 25.1509 7.79461C25.1509 9.91786 24.2053 11.9027 22.3899 14.1299C20.5674 16.3656 17.9471 18.7532 14.7174 21.6962L14.7098 21.7031L14.7082 21.7045L13.4028 22.8871L12.094 21.6925Z",
  fill: "#FF0000",
  stroke: "white",
  strokeWidth: 1.5
});

var SvgHeartActive = function SvgHeartActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-active.aae4e37b.svg";
export { ForwardRef as ReactComponent };